import Detail from 'components/SignUp/Detail'
import React, { Component } from 'react'
import { isMobile } from 'utils/common'

class SignUp extends Component {

  render() {
    const { location } = this.props
    const approvalCode = new URLSearchParams(location.search).get('code') || ''

    return (
      <div className={isMobile.any() ? "l-container" : "l-container push"}>
        <div className="content">
          <div className="main-page">
            <div className="mobile-screen">
              <Detail approvalCode={approvalCode} />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default SignUp
